import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { CrewCrudService } from 'src/app/shared/services/crew-crud.service';
import { Crew } from 'src/app/shared/interfaces/crew';


@Component({
  selector: 'app-crews',
  templateUrl: './crews.component.html',
  styleUrls: ['./crews.component.scss']
})
export class CrewsComponent implements OnInit {

  crews: Crew[];
  crew: Crew;
  selectedCrews: Crew[] = [];

  crewDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private crewService : CrewCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Crews'}
    ];

    this.crews = [];
    this.crew = { } as Crew ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.crewService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.crews = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Crew = jsonItem as Crew;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.crews.push(l);
          console.log('CREW',l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.crewService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.crews);
            doc.save('crews.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.crews);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "crews");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedCrews);
      // console.log('SAVEC CSV LOCATIONS ', this.crews);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedCrews, 'crews', exportCols);
   // this.exportService.exportToCsv(this.crews, 'crews', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.crew = {} as Crew;
    this.submitted = false;
    this.crewDialog = true;
  }

  deleteSelectedCrews() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected crews?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.crews = this.crews.filter(val => !this.selectedCrews.includes(val));
            
            this.selectedCrews.forEach( crew => this.crewService.delete(crew.$key));
            this.selectedCrews = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Crewss Deleted', life: 3000});
        }
    });
  }

  editCrew(crew: Crew) {
    this.crew = {...crew};
    this.crewDialog = true;
  }

  deleteCrew(crew: Crew) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + crew.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.crews = this.crews.filter(val => val.$key !== crew.$key);
            this.crew = {} as Crew;
            this.crewService.delete(crew.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Crew Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.crewDialog = false;
    this.submitted = false;
  }

  saveCrew() {
    this.submitted = true;

    if ( this.crew.name.trim() ) {
      if (this.crew.$key) {
          this.crews[this.findIndexById(this.crew.$key)] = this.crew;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Crew Updated', life: 3000});
          this.crewService.update(this.crew);
        } else {
          this.crew.position = this.crews.length;
          this.crewService.add(this.crew);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Crew Created', life: 3000});
      this.crews = [...this.crews];
    }

    this.crewDialog = false;
    this.crew = { } as Crew;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.crews.length; i++) {
        if (this.crews[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeCrew(crew : Crew) {
    this.crewService.update(crew);
  }

  completePosition(crew : Crew) {
    if ( this.newPosition > -1 ) {
        crew.position = this.newPosition;
        crew = this.checkPositionLimits(crew);
        this.reorderElements(crew);
        //this.updateDB(crew);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.crews);
    // const myClonedArray = [];
    // this.crews.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.crews.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.crews.length - 1 - event.dropIndex;
    const crewToMove = this.crews[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.crews[index] = this.crews[index+1];
        this.crews[index].position = index;
        this.crewService.update(this.crews[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.crews[index] = this.crews[index-1];
        this.crews[index].position = index;
        this.crewService.update(this.crews[index]);
      }
    } 
    this.crews[endIndex] = crewToMove;
    this.crews[endIndex].position = endIndex;
    this.crewService.update(this.crews[endIndex]);
  }

  // onFieldEdit(crew: Spray, fieldName: string): void {
  //   //console.log(this.crews);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + crew[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       crew.position = this.newPosition;
  //       crew = this.checkPositionLimits(crew);
  //       this.reorderElements(crew);
  //       //this.updateDB(crew);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(crew);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.crews.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, crew: Crew) {
    // console.log("event" +event);
    if (crew.position != null && crew.position > -1) {
      this.previousPosition = crew.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(crew: Crew) {
    console.log('check ',crew.position + ' ' + this.crews.length);
    if (!crew.position) {
     // console.log('check 1');
      return this.crew;
    }
    if (crew.position < 0) {
      crew.position = 0;
      // console.log('check 2');
      return crew;
    }
    if (crew.position > this.crews.length) {
      crew.position = this.crews.length - 1;
    //  console.log('check 3', crew.position);
      return crew;
    }
   // console.log('check 4');
    return crew;
  }

  async reorderElements(crew: Crew) {
    this.newPosition = this.newPosition  > this.crews.length ? this.crews.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === crew.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const crewToMove = this.crews[startIndex];
   // console.log('Item to move: ', this.crews[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.crews);
        console.log('Item to +1: ', this.crews[index+1]);

        this.crews[index] = this.crews[index+1];
        this.crews[index].position = index;
        // console.log('Move: ', this.crews[index+1]);
        // console.log('Move pos: ', this.crews[index].position);
        //await this.updateDB(this.crews[index]);
        this.crewService.update(this.crews[index]);
     //   console.log('Update DB: ', this.crews[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.crews[index] = this.crews[index-1];
        this.crews[index].position = index;
        this.crewService.update(this.crews[index]);
      }
    } 
    this.crews[endIndex] = crewToMove;
    this.crews[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.crewService.update(this.crews[endIndex]);
    
    // const myClonedArray = [];
    // this.crews.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.crews = myClonedArray;
   // this.getAllRecords();
  }
}
